import { isStandardOrder } from '../../utils/order-type-utils';
import { getOrder } from '../order/get-order';
export const getOrderTicketRedemptionCards = () => {
    const order = getOrder();
    return isStandardOrder(order) ? order.ticketRedemptionCards : [];
};
